import { Text } from '@mantine/core';
import { type PayoutCascadeTemplate } from '~/entities/payout';
import { type TableCell, type TableData, type TableRow } from '~/shared/ui/Table';

const prepareHeaders: TableCell[] = [
    { key: 'id', content: 'ID', ta: 'center' },
    { key: 'name', content: 'Название', ta: 'center' },
    { key: 'groups', content: 'Группы', ta: 'center' },
];

type PrepareTableDataProps = {
    templates?: PayoutCascadeTemplate[];
};

const formatGroupNames = (template: PayoutCascadeTemplate) => {
    if (!template.groups?.length) {
        return '—';
    }

    return template.groups.map((group) => group.name?.value || group.id?.value).join(', ');
};

const prepareRows = ({ templates }: PrepareTableDataProps): TableRow<PayoutCascadeTemplate>[] => {
    if (!templates) {
        return [];
    }

    return templates.map((template) => ({
        key: template.id?.value ?? 0,
        cells: [
            { key: 'id', content: <Text ta='center'>{template.id?.value}</Text> },
            { key: 'name', content: <Text ta='center'>{template.name?.value}</Text> },
            { key: 'groups', content: <Text ta='center'>{formatGroupNames(template)}</Text> },
        ],
        item: template,
    }));
};

export const createTableData = ({ templates }: PrepareTableDataProps): TableData<PayoutCascadeTemplate> => {
    return {
        head: prepareHeaders,
        rows: prepareRows({ templates }),
        caption: templates?.length === 0 ? 'Шаблонов нет' : undefined,
    };
};
